import Callout from './component.jsx'
export default Callout
